<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>adb</mat-icon>
        </button>
        <span>Assistent</span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn">
            <mat-icon (click)="cancel()">close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content" [formGroup]="formGroup">

        <mat-form-field class="width" appearance="fill">
            <mat-label>Anzahl</mat-label>
            <input formControlName="number" matInput>
        </mat-form-field>

        <app-select-product-form formControlName="product" useMaterialInput="true"></app-select-product-form>

        <mat-form-field appearance="fill">
            <input formControlName="faktDate" placeholder="Fakturierungsdatum" [matDatepicker]="faktDatePicker" matInput
                readonly />
            <mat-datepicker-toggle matSuffix [for]="faktDatePicker"></mat-datepicker-toggle>
            <button mat-icon-button matSuffix (click)="faktDateControl.setValue(null)">
                <mat-icon>clear</mat-icon>
            </button>
            <mat-datepicker #faktDatePicker disabled="false"></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <input formControlName="buildInDate" placeholder="Einbaudatum" [matDatepicker]="buildInDatePicker" matInput
                readonly />
            <mat-datepicker-toggle matSuffix [for]="buildInDatePicker"></mat-datepicker-toggle>
            <button mat-icon-button matSuffix (click)="buildInDateControl.setValue(null)">
                <mat-icon>clear</mat-icon>
            </button>
            <mat-datepicker #buildInDatePicker disabled="false"></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <input formControlName="cancelDate" placeholder="Kündigungsdatum" [matDatepicker]="cancelDatePicker"
                matInput readonly />
            <mat-datepicker-toggle matSuffix [for]="cancelDatePicker"></mat-datepicker-toggle>
            <button mat-icon-button matSuffix (click)="cancelDateControl.setValue(null)">
                <mat-icon>clear</mat-icon>
            </button>
            <mat-datepicker #cancelDatePicker disabled="false"></mat-datepicker>
        </mat-form-field>

        <div class="price-wrapper">

            <mat-form-field appearance="fill">
                <mat-label>Einrichtung</mat-label>
                <input formControlName="setupPrice" (blur)="transformAmount($event)" matInput />
                <mat-icon class="suffix-icon" matSuffix>euro_symbol</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Mietpreis</mat-label>
                <input formControlName="rentalPrice" (blur)="transformAmount($event)" matInput />
                <mat-icon class="suffix-icon" matSuffix>euro_symbol</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Kaufpreis</mat-label>
                <input formControlName="purchasePrice" (blur)="transformAmount($event)" matInput />
                <mat-icon class="suffix-icon" matSuffix>euro_symbol</mat-icon>
            </mat-form-field>

        </div>

        <div class="control-row">

            <button mat-raised-button color="warn" (click)="cancel()">
                Abbrechen
            </button>

            <button [disabled]="formGroup.invalid" mat-raised-button color="primary" (click)="confirm()">
                Anlegen
            </button>

        </div>
    </div>
</div>